import { memo } from "react";
import PropTypes from "prop-types";
import "./AvailablePaymentTerms.scss";
import { FormattedMessage } from "react-intl";
import IconPaiement2x from "app/pages/.shared/static/icons/IconPaiement2x";
import IconPaiement4x from "app/pages/.shared/static/icons/IconPaiement4x";
import IconPaiement10x from "app/pages/.shared/static/icons/IconPaiement10x";
import IconDeposit from "app/pages/.shared/IconDeposit";
import IconLogoAlma from "app/pages/.shared/static/icons/IconLogoAlma";
import { PAYMENT_OPTIONS } from "app/constants";
import { useFsFlag } from "@flagship.io/react-sdk";

const AvailablePaymentTerms = ({
	availablePaymentTerms = [],
	isDepositEnabled = false,
	hasAlmaPayment = false,
	isPaymentWithoutFee,
}) => {
	const show10XPaymentMethod = useFsFlag("available_payment_method_10x_show", true);
	const has4xAlmaPayment = availablePaymentTerms.includes(PAYMENT_OPTIONS["4x"]);
	const has10xAlmaPayment = availablePaymentTerms.includes(PAYMENT_OPTIONS["10x"]);

	return (
		availablePaymentTerms.length > 1 && (
			<div className="available-payment-terms" data-testid="available-payment-terms">
				<div className="available-payment-terms__title">
					<FormattedMessage
						id="available.payment.terms.prefix"
						values={{
							withoutFee: isPaymentWithoutFee && (
								<strong>
									<FormattedMessage id="general.sans.frais" />
								</strong>
							),
						}}
					/>
				</div>

				<div className="available-payment-terms__pictos">
					{availablePaymentTerms.map(term => {
						let picto = false;

						if (term === PAYMENT_OPTIONS["2x"]) {
							if (isDepositEnabled) {
								picto = <IconDeposit />;
							} else {
								picto = <IconPaiement2x />;
							}
						} else if (term === PAYMENT_OPTIONS["4x"]) {
							picto = <IconPaiement4x />;
						} else if (
							term === PAYMENT_OPTIONS["10x"] &&
							show10XPaymentMethod.getValue()
						) {
							picto = <IconPaiement10x />;
						}

						return (
							<div key={term} className="available-payment-terms__picto">
								{picto}
							</div>
						);
					})}
					{hasAlmaPayment &&
						(has4xAlmaPayment ||
							(has10xAlmaPayment && show10XPaymentMethod.getValue())) && (
							<div className="available-payment-terms__picto">
								<IconLogoAlma width={35} />
							</div>
						)}
				</div>
			</div>
		)
	);
};

AvailablePaymentTerms.propTypes = {
	availablePaymentTerms: PropTypes.array,
	isDepositEnabled: PropTypes.bool,
	hasAlmaPayment: PropTypes.bool,
	isPaymentWithoutFee: PropTypes.bool,
};

export default memo(AvailablePaymentTerms);
